/**
 * The persistent identity of each Taken page, for the services that key state per overview.
 *
 * ⚠ **None of these may begin with `/`.** `GetOverviewId()` returns either `''` or a `/`-prefixed path, so
 * a literal that does not start with `/` cannot collide with a route-derived id. The Taken routes resolve
 * to `''`, which every other consumer reads as "no persistent identity", so they carry a literal instead of
 * gaining `data.isOverview`.
 *
 * The three live together because the collision they guard against is a cross-app one: `localStorage` is
 * per origin, and all three apps dev-serve on `http://localhost:4200`.
 */
export const TaskOverviewId = {
    EdepotEvaluate: 'tasks:edepot-evaluate',
    SerieregisterEvaluate: 'tasks:serieregister-evaluate',
    DepotManagement: 'tasks:depot-management'
} as const;
